<template>
    <div class="not-defined content">
        <!--    <img src="@assets/images/404.png" />-->

        <div class="content">
            <h3 class="title">页面未找到</h3>
            <span
            >抱歉！您访问的页面不存在，请返回上一级或点击下方按钮返回首页...</span
            >
        </div>

        <div class="btn" @click="$router.replace({ path: '/' })">
            返回首页
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotDefined"
    };
</script>

<style scoped>
    .not-defined {
        /*background: url("../assets/images/main-bg.png") repeat;*/
      margin: 60px auto;
      height: 100%;
    }

    .not-defined img {
        width: 100%;
        margin-top: 18%;
    }

    .content {
        padding: 60px 10px;
        text-align: center;
        color: #44405e;
        font-size: 15px;
    }

    .title {
        margin-bottom: 50px;
        color: #302c48;
        font-size: 20px;
    }

    .btn {
        color: #fff;
        background-color: #ef4c4c;
        font-size: 16px;
        padding: 20px;
        border-radius: 25px;
        text-align: center;
        width: 200px;
        margin: 0 auto;
        margin-top: 50px;
    }
</style>
